module.exports = __webpack_public_path__ + "assets/search.4bd36860.svg";